exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1DZexGsEN-azo1eBwtEXoE:after{content:\"admin\";vertical-align:top;font-size:8px;display:inline-block}\n", ""]);

// Exports
exports.locals = {
	"AdminOnly": "_1DZexGsEN-azo1eBwtEXoE"
};